/* 🤖 this file was generated by svg-to-ts */
export const matIconAutoAwesome: {
  name: 'auto-awesome';
  data: string;
} = {
  name: 'auto-awesome',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m19 9 1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25zm0 6-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25zm-7.5-5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zm-1.51 3.49L9 15.17l-.99-2.18L5.83 12l2.18-.99L9 8.83l.99 2.18 2.18.99-2.18.99z"/></svg>`
};
